import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectAllProducts } from "../../../redux/slices/productsSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import StoreCategoriesList from "./StoreCategoriesList";

const ConnectedStoreCategoriesList = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const products = useSelector(selectAllProducts);
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_P2P_STORE,
            state,
        ),
    );
    const {
        options: { sectionHeading = "Optional Add-ons" },
    } = control;

    const storeCategoriesListProps = {
        controlId,
        sectionHeading,
        products,
    };
    return <StoreCategoriesList {...storeCategoriesListProps} />;
};

ConnectedStoreCategoriesList.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedStoreCategoriesList;
